import { configureStore } from "@reduxjs/toolkit";
// import globalStateSlice from "./slices/globalStateSlice";
// import entitySelectionSlice from "./slices/entitySelectionSlice";
// import entityAggregateSlice from "./slices/entityAggregateSlice";
// import entitySlice from "./slices/entitySlice";
import aggSlice from "./slices/aggSlice";
import selectionsSlice from "./slices/selectionsSlice";
// import matrixMiddleware, { reHydrateStore } from "./middlewares/matrixMiddleware";


const store = configureStore({
    reducer: {
        // entitySelection:              entitySelectionSlice.reducer,
        // entityAggregate:              entityAggregateSlice.reducer,
        // entity:                       entitySlice.reducer,
        // globalState:                  globalStateSlice.reducer,
        agg:                       aggSlice.reducer,
        selection:                       selectionsSlice.reducer
    },
    // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(matrixMiddleware)
})

export default store;